import { GetArchivedChannelRes, UpdateArchivedStatusOfChannelReq } from "../../interfaces/channelDtos/channelDtos";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

export async function UpdateArchivedStatusOfChannelAsync(
    request: UpdateArchivedStatusOfChannelReq,
    authToken: string
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/channel/update/ArchivedStatus`;

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(request),
        });

        return await response.json();
    } catch (err) {
        throw err;
    }
}

export async function GetAllArchivedChannelsAsync(
    authToken: string
): Promise<ApiResponse<GetArchivedChannelRes[]>> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/channel/GetAllArchivedChannels`;

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        });

        return await response.json();
    } catch (err) {
        throw err;
    }
}
